'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Set the background image as a media query
var setTileMediaQueries = function setTileMediaQueries(wrapperTile) {
  var tile = wrapperTile;
  var tileIdentifier = tile.getAttribute('data-io-id');
  var tileImagesRaw = tile.getAttribute('data-io-srcset');
  var tileImages = tileImagesRaw.split(',');
  var stylesElement = document.createElement('style');
  tileImages.forEach(function (tileImage) {
    var imageParts = tileImage.trim().split(' ');
    stylesElement.innerHTML += '@media screen and (min-width: ' + imageParts[1] + ') {\n      [data-io-id="' + tileIdentifier + '"] {\n        background-image: url("' + imageParts[0] + '");\n      }\n    }';
  });
  document.body.appendChild(stylesElement);
};

// check if we're setting a srcset, otherwise just set the background image
var setTileBackground = function setTileBackground(wrapperTile) {
  var tile = wrapperTile;
  if (tile.hasAttribute('data-io-srcset')) {
    setTileMediaQueries(tile);
  } else if (tile.hasAttribute('data-img-src')) {
    var src = tile.getAttribute('data-img-src');
    tile.setAttribute('src', src);
    if (tile.hasAttribute('data-img-srcset')) {
      var srcset = tile.getAttribute('data-img-srcset');
      tile.setAttribute('srcset', srcset);
    }
  } else {
    var backgroundURL = tile.getAttribute('data-io-src');
    tile.style.backgroundImage = 'url(\'' + backgroundURL + '\')';
  }
};

// watch for tiles entering the screen - once they do set images
// and remove them from list of observed entries (don't need to watch
// since backgrounds are already set)
var observeTileChange = function observeTileChange(entries, observer) {
  entries.forEach(function (entry) {
    if (observer) {
      if (entry.isIntersecting) {
        setTileBackground(entry.target);
        observer.unobserve(entry.target);
      }
    } else {
      // IOs not supported, display the entry
      setTileBackground(entry);
    }
  });
};

// Binds an observer to given elements if IOs exist in the browser
var createObservers = function createObservers(_ref) {
  var toObserve = _ref.toObserve,
      callback = _ref.callback,
      margins = _ref.margins;

  // check if IOs are available or not
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(callback, {
      rootMargin: margins
    });
    // have to bind to each individual tile
    toObserve.forEach(function (tile) {
      observer.observe(tile);
    });
  } else {
    // if there are no IOs in the browser, just display them now.
    callback(toObserve, false);
  }
};

// setup some generic observers:
//  - queryString: the DOM query for grabbing all elements to observe
//  - callback: the callbaack function for when the tiles enter/exit the view
//  - margins: string representing the bounds for when the tiles load
var setupObservers = function setupObservers() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$queryString = _ref2.queryString,
      queryString = _ref2$queryString === undefined ? '[data-io-src], [data-io-srcset], [data-img-src]' : _ref2$queryString,
      _ref2$callback = _ref2.callback,
      callback = _ref2$callback === undefined ? observeTileChange : _ref2$callback,
      _ref2$margins = _ref2.margins,
      margins = _ref2$margins === undefined ? '0% 0% 0% 0%' : _ref2$margins;

  // observers for images
  var toObserve = document.querySelectorAll(queryString);
  createObservers({
    toObserve: toObserve,
    callback: callback,
    margins: margins
  });
};

exports.default = {
  setupObservers: setupObservers
};